export default {
  EAT_CAT: 'cat',
  EAT_CRATE: 'crate',
  EAT_FLAG: 'flag',
}
